import useIsNarrowerThan from '@liveauctioneers/caterwaul-components/lib/hooks/useIsNarrowerThan';
import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';

import { CategoryCard } from './components/CategoryCard/CategoryCard';

export type RelatedCategory = {
    href: string;
    imageUrl: string;
    imageVersion: number;
    title: string;
};

const relatedCategories: RelatedCategory[] = [
    {
        href: '/search/?keyword=star%20wars%20signed',
        imageUrl: 'https://p1.liveauctioneers.com/7804/368859/202891577_1_x.jpg',
        imageVersion: 1743530095,
        title: 'Signed Collectables',
    },
    {
        href: '/search/?keyword=star%20wars%20figurine&sort=-relevance&status=online',
        imageUrl: ' https://p1.liveauctioneers.com/6629/366363/201403558_1_x.jpg',
        imageVersion: 1741796858,
        title: 'Figures & Figurines',
    },
    {
        href: '/search/?category_id=24&keyword=star%20wars%20coin&sort=-relevance&status=online',
        imageUrl: 'https://p1.liveauctioneers.com/6899/367399/203001757_1_x.jpg',
        imageVersion: 1743577265,
        title: 'Coins',
    },
    {
        href: '/search/?keyword=star%20wars%20card&sort=-relevance&status=online',
        imageUrl: 'https://p1.liveauctioneers.com/7804/368983/203016821_1_x.jpg',
        imageVersion: 1743616455,
        title: 'Trading Cards ',
    },
    {
        href: '/search/?category_id=14777&keyword=star%20wars&sort=-relevance&status=online',
        imageUrl: 'https://p1.liveauctioneers.com/3780/369225/203217637_1_x.jpg',
        imageVersion: 1743723754,
        title: 'LEGO',
    },
    {
        href: '/search/?category_id=6&keyword=star%20wars&sort=-relevance&status=online',
        imageUrl: 'https://p1.liveauctioneers.com/3780/368953/202993661_1_x.jpg',
        imageVersion: 1743557734,
        title: 'Watches & Jewelry',
    },
];

export const RelatedCategories = () => {
    const isTabletSize = useIsNarrowerThan(768);
    const { formatMessage } = useIntl();

    if (isTabletSize) {
        const cards = Object.values(relatedCategories).map((categoryCard) => ({
            card: (
                <CategoryCard
                    href={categoryCard.href}
                    imageUrl={categoryCard.imageUrl}
                    imageVersion={categoryCard.imageVersion}
                    title={categoryCard.title}
                />
            ),
            key: categoryCard.title,
        }));

        return (
            <div className="pb-lg">
                <Carousel
                    cards={cards}
                    title={formatMessage({ id: 'searchPage.promotedEvent.exploreCategories' })}
                    useOverlayControls
                />
            </div>
        );
    }

    return (
        <div className="pb-lg">
            <H2>{formatMessage({ id: 'searchPage.promotedEvent.exploreCategories' })}</H2>

            <div className="mt-sm flex gap-md">
                {relatedCategories.map(({ href, imageUrl, imageVersion, title }, index) => (
                    <CategoryCard
                        href={href}
                        imageUrl={imageUrl}
                        imageVersion={imageVersion}
                        key={index}
                        title={title}
                    />
                ))}
            </div>
        </div>
    );
};
